import { AxiosError } from 'axios';
import { create } from 'sortablejs';
import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';
import {
  ControlDetailData,
  ControlGpData,
  ControlGpState,
  ControlGpDtlState,
  ControlGpFlightPlanDataList,
  ControlGpWarnLogData,
  ControlGpLogState,
  ControlGpHisState,
  ControlGpPlanContainsRQ,
  ControlGpPlanContainsRS,
  // ControlGroupAuthState,
  ControlGpArcrftWarnList,
  ControlGpWarnLogList,
  ControlweatherData,
  rescontrolweatherData,
  ControlGpArcrftWarnRq,
  ControlGpCountState
} from '../models/controlGpModel';

const CONTROL_GP_REQUEST = 'control/gp/CONTROL_GP_REQUEST';
const CONTROL_GP_SUCCESS = 'control/gp/CONTROL_GP_SUCCESS';
const CONTROL_GP_FAILURE = 'control/gp/CONTROL_GP_FAILURE';

const CONTROL_GP_HIS_REQUEST = 'control/gp/CONTROL_GP_HIS_REQUEST';
const CONTROL_GP_HIS_SUCCESS = 'control/gp/CONTROL_GP_HIS_SUCCESS';
const CONTROL_GP_HIS_FAILURE = 'control/gp/CONTROL_GP_HIS_FAILURE';

const CONTROL_GP_DTL_REQUEST = 'control/gp/CONTROL_GP_DTL_REQUEST';
const CONTROL_GP_DTL_SUCCESS = 'control/gp/CONTROL_GP_DTL_SUCCESS';
const CONTROL_GP_DTL_FAILURE = 'control/gp/CONTROL_GP_DTL_FAILURE';

const CONTROL_GP_RTDTL_REQUEST = 'control/gp/CONTROL_GP_RTDTL_REQUEST';
const CONTROL_GP_RTDTL_SUCCESS = 'control/gp/CONTROL_GP_RTDTL_SUCCESS';
const CONTROL_GP_RTDTL_FAILURE = 'control/gp/CONTROL_GP_RTDTL_FAILURE';

// [관제] 그룹 권한 및 기체 식별번호 조회
const CONTROL_GROUP_AUTH_REQUEST = 'control/group/CONTROL_GROUP_AUTH_REQUEST';
const CONTROL_GROUP_AUTH_SUCCESS = 'control/group/CONTROL_GROUP_AUTH_SUCCESS';
const CONTROL_GROUP_AUTH_FAILURE = 'control/group/CONTROL_GROUP_AUTH_FAILURE';

// [관제] 비행 구역 조회
const CONTROL_FLIGHT_PLAN_REQUEST =
  'control/gp/flight/plan/CONTROL_FLIGHT_PLAN_REQUEST';
const CONTROL_FLIGHT_PLAN_SUCCESS =
  'control/gp/flight/plan/CONTROL_FLIGHT_PLAN_SUCCESS';
const CONTROL_FLIGHT_PLAN_FAILURE =
  'control/gp/flight/plan/CONTROL_FLIGHT_PLAN_FAILURE';

//로그 리스트 조회
const CONTROL_GP_LOG_REQIEST = 'control/gp/CONTROL_GP_LOG_REQUEST';
const CONTROL_GP_LOG_SUCCESS = 'control/gp/CONTROL_GP_LOG_SUCCESS';
const CONTROL_GP_LOG_FAILURE = 'control/gp/CONTROL_GP_LOG_FAILURE';

//날씨 API
const CONTROL_WEATHER_REQUEST = 'control/gp/CONTROL_WEATHER_REQUEST';
const CONTROL_WEATHER_SUCCESS = 'control/gp/CONTROL_WEATHER_SUCCESS';
const CONTROL_WEATHER_FAILURE = 'control/gp/CONTROL_WEATHER_FAILURE';

const CONTROL_FLIGHT_PLAN_INIT =
  'control/gp/flight/plan/CONTROL_FLIGHT_PLAN_INIT';

// [관제] 비행 구역 비정상 여부 체크
const CONTROL_FLIGHT_PLAN_WARN_REQUEST =
  'control/gp/flight/plan/CONTROL_FLIGHT_PLAN_WARN_REQUEST';
const CONTROL_FLIGHT_PLAN_WARN_SUCCESS =
  'control/gp/flight/plan/CONTROL_FLIGHT_PLAN_WARN_SUCCESS';
const CONTROL_FLIGHT_PLAN_WARN_FAILURE =
  'control/gp/flight/plan/CONTROL_FLIGHT_PLAN_WARN_FAILURE';

// [관제] 기체 별 비정상 리스트 조회
const CONTROL_GP_ARCRFT_WARN_REQUEST =
  'control/gp/arcrft/warn/CONTROL_FLIGHT_PLAN_WARN_REQUEST';
const CONTROL_GP_ARCRFT_WARN_SUCCESS =
  'control/gp/arcrft/warn/CONTROL_FLIGHT_PLAN_WARN_SUCCESS';
const CONTROL_GP_ARCRFT_WARN_FAILURE =
  'control/gp/arcrft/warn/CONTROL_FLIGHT_PLAN_WARN_FAILURE';

// [관제] 비행중인 기체 수 카운트
const CONTROL_GP_COUNT_REQUEST =
  'control/gp/flight/count/CONTROL_GP_COUNT_REQUEST';
const CONTROL_GP_COUNT_SUCCESS =
  'control/gp/flight/count/CONTROL_GP_COUNT_SUCCESS';
const CONTROL_GP_COUNT_FAILURE =
  'control/gp/flight/count/CONTROL_GP_COUNT_FAILURE';

export const controlGpAction = createAsyncAction(
  CONTROL_GP_REQUEST,
  CONTROL_GP_SUCCESS,
  CONTROL_GP_FAILURE
)<ControlGpData[], ControlGpState, AxiosError>();

export const controlGpHisAction = createAsyncAction(
  CONTROL_GP_HIS_REQUEST,
  CONTROL_GP_HIS_SUCCESS,
  CONTROL_GP_HIS_FAILURE
)<{ id: string }, ControlGpHisState, AxiosError>();

export const controlGpDtlAction = createAsyncAction(
  CONTROL_GP_DTL_REQUEST,
  CONTROL_GP_DTL_SUCCESS,
  CONTROL_GP_DTL_FAILURE
)<string, ControlDetailData, AxiosError>();

export const controlGpRtDtlAction = createAsyncAction(
  CONTROL_GP_RTDTL_REQUEST,
  CONTROL_GP_RTDTL_SUCCESS,
  CONTROL_GP_RTDTL_FAILURE
)<ControlGpData, ControlGpDtlState, AxiosError>();

// export const controlGroupAuthAction = createAsyncAction(
//   CONTROL_GROUP_AUTH_REQUEST,
//   CONTROL_GROUP_AUTH_SUCCESS,
//   CONTROL_GROUP_AUTH_FAILURE
// )<string, ControlGroupAuthState, AxiosError>();

export const controlGpFlightPlanAction = createAsyncAction(
  CONTROL_FLIGHT_PLAN_REQUEST,
  CONTROL_FLIGHT_PLAN_SUCCESS,
  CONTROL_FLIGHT_PLAN_FAILURE
)<string, ControlGpFlightPlanDataList, AxiosError>();

export const controlGpLogAction = createAsyncAction(
  CONTROL_GP_LOG_REQIEST,
  CONTROL_GP_LOG_SUCCESS,
  CONTROL_GP_LOG_FAILURE
)<{ id: string }, ControlGpWarnLogList, AxiosError>();

export const controlGpFlightPlanWarnAction = createAsyncAction(
  CONTROL_FLIGHT_PLAN_WARN_REQUEST,
  CONTROL_FLIGHT_PLAN_WARN_SUCCESS,
  CONTROL_FLIGHT_PLAN_WARN_FAILURE
)<ControlGpPlanContainsRQ, ControlGpPlanContainsRS, AxiosError>();

export const controlGpArcrftWarnAction = createAsyncAction(
  CONTROL_GP_ARCRFT_WARN_REQUEST,
  CONTROL_GP_ARCRFT_WARN_SUCCESS,
  CONTROL_GP_ARCRFT_WARN_FAILURE
)<ControlGpArcrftWarnRq, ControlGpArcrftWarnList, AxiosError>();

export const controlweatherAction = createAsyncAction(
  CONTROL_WEATHER_REQUEST,
  CONTROL_WEATHER_SUCCESS,
  CONTROL_WEATHER_FAILURE
)<ControlweatherData, rescontrolweatherData, AxiosError>();

export const controlGpFlightPlanInitAction = createAction(
  CONTROL_FLIGHT_PLAN_INIT
)();

export const controlGpCountAction = createAsyncAction(
  CONTROL_GP_COUNT_REQUEST,
  CONTROL_GP_COUNT_SUCCESS,
  CONTROL_GP_COUNT_FAILURE
)<ControlGpCountState, ControlGpCountState, AxiosError>();

const actions = {
  controlGpAction,
  controlGpHisAction,
  controlGpLogAction,
  controlGpDtlAction,
  controlGpRtDtlAction,
  // controlGroupAuthAction,
  controlGpFlightPlanAction,
  controlGpFlightPlanWarnAction,
  controlGpArcrftWarnAction,
  controlGpFlightPlanInitAction,
  controlweatherAction
  // controlGpCountAction
};

export type ControlGpAction = ActionType<typeof actions>;
